import { Component, Inject, OnInit } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeleteConfirmData } from './delete-modal.interface';

@Component({
  selector: 'arsultima-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss'],
})
export class DeleteModalComponent implements OnInit {
  message: DeleteConfirmData = {
    confirmMessage: 'confirmDeletePopup.message',
    confirm: 'confirmDeletePopup.confirm',
    cancel: 'confirmDeletePopup.cancel',
  };

  constructor(
    private readonly dialogRef: MatDialogRef<DeleteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteConfirmData,
  ) {
    if (data) {
      this.message = {
        ...this.message,
        ...data,
      };
    }
  }

  ngOnInit(): void {}

  doNotDelete() {
    this.dialogRef.close(false);
  }

  delete() {
    this.dialogRef.close(true);
  }
}
